<template>
	<div>
		<ts-loading-banner :loading="loading">
			<div class="ts-flex ts-jus">
				<div class="ts-relative ts-w-full">
					<input 
						v-model.trim="search"
						ref="search"
						type="text" class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
						:placeholder="$t('stockAdjustment.searchProductList')"
					>
					<span class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2" style="margin-top: 7px"><i class="fa fa-search"></i></span>
				</div>
			</div>
			<br>
			<div class="max-h ts-px-3">
				<table class="ts-w-full">
					<thead>
						<tr>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap" >{{$t('stockAdjustment.productGroup') }}</th>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap" >{{$t('stockAdjustment.barcode') }}</th>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap" >{{$t('stockAdjustment.productName') }}</th>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center" >{{$t('stockAdjustment.qty') }}</th>
							<th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap" >{{ $t('actions') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr 
						class="ts-border-b ts-border-gray-300"
						v-for="(product, index) in productList"
						:key="index"
					>
						<td class="ts-text-xs">{{ product.pro_group_name_en }}</td>
						<td class="ts-text-xs">{{ product.barcode }}</td>
						<td class="ts-text-xs">{{ product.product_name_en }}</td>
						<td class="ts-text-center">
							<input 
								v-model="product.quantity"
								type="number" placeholder="qty" 
								class="ts-w-16 ts-outline-none ts-border-t ts-px-2 ts-py-1 ts-rounded ts-mt-2 ts-text-xs ts-text-center"
								@keypress.enter="addItem(product)"
							>
						</td>
						<td style="width:1%" class="text-center ts-pl-4">
							<a href="#"
								v-tooltip="$t('add')"
								@click.prevent="addItem(product)"
								class="ts-mb-0"
							>
								<i class="fa fa-plus"></i>
							</a>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</ts-loading-banner>
	</div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
	name: 'productList',
	props: ['value'],
	data(){
		return {
			search: '',
			loading: false,
			products: [],
			model: {}
		}
	},
	created() {
    this.model = this.value
		this.fetchProduct()
		this.$nextTick(() => {
			this.$refs.search.focus();
		});
  },
	computed: {
    ...mapGetters('stock/adjustment', ['isDefaultUom', 'getUom']),
    productList() {
      return this.products.filter(p => !_.includes(this.model.sub_item_list.map(el => el.product_id),p.product_id))
    },
	},
	methods: {
		...mapActions('stock/adjustment', ['getProduct', 'getSysQty']),
		async getSystemQty(product_id){
			this.$emit('loading', true)
			let response = await this.getSysQty(product_id)
			this.$emit('loading', false)
      return response.data.ending_balance
		},
		async addItem(product) {
			// push product to state
			this.$store.commit('stock/adjustment/SET_PRODUCT', product)

			var currentQyt = await this.getSystemQty(product.product_id)
			this.model.sub_item_list.push({
					product_id: product.product_id,
					product_name_en: product.product_name_en,
					barcode: product.barcode,
					uom_id: this.isDefaultUom(product.product_id),
					uom_name_en: this.getUom(product.product_id).uom_name_en,
					current_qty: currentQyt,
					new_qty: null,
					qty_different: currentQyt,
					reason: null
			})
		},
    fetchProduct(){
      this.loading = true
      this.products = []
      this.getProduct({ filter: {
        search: this.search
      }})
        .then(response => {
          this.products = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
	},
	watch: {
    search: debounce(function (search) {
      this.fetchProduct()
    }, 500),
  }
}
</script>

<style scoped>
.max-h {
  height: 240px;
  max-height: 250px;
  overflow: scroll;
}
table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  border-spacing: 0;
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
</style>